"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    studentsDetails: {
        highlight: 'Highlight items',
        table: {
            student: 'Student Name',
            assessment: 'Assessment',
            overall: 'Overall',
            multipleAttempts: '+ 2 attempts',
            seeDetails: 'See student details',
            closeDetails: 'Close student details',
            next: 'next',
        },
        question: 'Q{{count}}',
        total: 'total',
        word: 'Word {{value}}',
        criterion: 'Criterion {{value}}',
        ratingCriterias: {
            '4': 'EE',
            '3': 'ME',
            '2': 'PME',
            '1': 'DNME',
        },
    },
};
